export const WRITING_COACH_CONTENT_DESCRIPTOR =
    "AIGuideActivity:x1e6d165d54a37115";

export const containsWritingCoachContent = (
    contentDescriptorsList: Array<string>,
): boolean => {
    return contentDescriptorsList.includes(WRITING_COACH_CONTENT_DESCRIPTOR);
};
